<template>
  <div class="calendar-wrapper">
    <div class="calendar">
      <div class="calendar-header">
        <h2 class="desktop">
          Календар >
          <template v-if="activeContentTab === 0"
            >График планирани и отчетени служители</template
          >
          <template v-else-if="activeContentTab === 1">
            Механизация за
            <template v-if="activePeriodTab === 0">деня</template>
            <template v-if="activePeriodTab === 1">седмицата</template>
          </template>
          <template v-else-if="activeContentTab === 2">Личен график</template>
          <template v-else-if="activeContentTab === 3"
            >Модул Човешки ресурси</template
          >
        </h2>
        <div class="selected-date desktop">
          <p v-if="activePeriodTab === 0">
            <strong>{{ date | formatDay }}</strong>
            <span>, {{ date | formatDayOfWeek }}</span>
          </p>
          <p v-if="activePeriodTab === 1">
            <strong>{{ firstDay | formatDay }}</strong>
            -
            <strong>{{ lastDay | formatDay }}</strong>
          </p>
        </div>
        <div class="mobile-datepicker">
          <div
            class="mobile-datepicker-toggle"
            @click="showMobileDatepicker = !showMobileDatepicker"
          >
            <span v-if="activePeriodTab === 0">{{ date | formatDay }}</span>
            <span v-if="activePeriodTab === 1"
              >{{ firstDay | formatDay }} - {{ lastDay | formatDay }}</span
            >
            <span class="mck" :class="{ 'rotate-arrow': showMobileDatepicker }"
              >K</span
            >
          </div>
          <div
            class="mobile-datepicker-wrapper"
            :class="{
              'left-panel-week-mode': activePeriodTab === 1,
              'left-panel-day-mode': activePeriodTab === 0,
            }"
            v-show="showMobileDatepicker"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :minimumView="'day'"
              :highlighted="highlighted"
              :maximumView="'day'"
              :full-month-name="true"
              v-model="date"
            ></datepicker>
          </div>
        </div>
        <div class="calendar-header-left" v-if="activeContentTab !== 3">
          <label class="desktop" for="views1">Изглед по:</label>
          <div class="views" id="views1">
            <button
              class="view left"
              :class="{ 'view-active': activePeriodTab === 0 }"
              @click="changePeriodTab(0)"
            >
              <span class="desktop">Ден</span>
              <span class="mck2 mobile-inline">T</span>
            </button>
            <button
              class="view right"
              :class="{ 'view-active': activePeriodTab === 1 }"
              @click="changePeriodTab(1)"
            >
              <span class="desktop">Седмица</span>
              <span class="mck2 mobile-inline">S</span>
            </button>
            <!-- <button class="view right" :class="{ 'view-active' : activePeriodTab === 2 }">Месец</button> -->
          </div>
        </div>
        <div class="btns" v-else>
          <a
            class="btn btn-excel btn-widthless"
            :href="normativeUrl"
            target="_blank"
            @click="toggleExport($event)"
          >
            <span class="mck">E</span>
            Справка Норматив м. {{ date | getMonth }}
          </a>
          <a class="btn btn--help" :href="normativePdf" target="_blank">?</a>
        </div>
      </div>
      <div class="calendar-content">
        <div
          class="left-panel"
          :class="{
            'left-panel-week-mode': activePeriodTab === 1,
            'left-panel-day-mode': activePeriodTab === 0,
          }"
        >
          <div class="left-panel-header">
            <div class="views" id="views2">
              <button
                v-if="accessCache['0']"
                class="view left"
                :class="{ 'view-active': activeContentTab === 0 }"
                @click="changeContentTab(0)"
              >
                График
              </button>
              <button
                v-if="accessCache['0']"
                class="view right"
                :class="{ 'view-active': activeContentTab === 1 }"
                @click="changeContentTab(1)"
              >
                Механизация
              </button>
              <button
                v-if="accessCache['0'] || accessCache['2']"
                class="view right"
                :class="{ 'view-active': activeContentTab === 2 }"
                @click="changeContentTab(2)"
              >
                Личен
              </button>
              <button
                v-if="accessCache['3'] || accessCache['normative']"
                class="view right"
                :class="{ 'view-active': activeContentTab === 3 }"
                @click="changeContentTab(3)"
              >
                ЧР
              </button>
            </div>
          </div>
          <datepicker
            class="desktop"
            :language="bg"
            :inline="true"
            :monday-first="true"
            :minimumView="'day'"
            :highlighted="highlighted"
            :maximumView="'day'"
            :full-month-name="true"
            v-model="date"
            @changedMonth="changeMonth"
          ></datepicker>
          <div
            v-if="accessCache['3'] === 'edit'"
            class="new-content-data-item-toggle desktop"
            :class="{
              'new-content-data-item-toggle--hoverable': activeContentTab === 3,
            }"
            @click="openAddAbsencesModal()"
          >
            <p>
              <transition name="fade">
                <span class="mck2" v-if="activeContentTab === 3">0</span>
              </transition>
              <transition name="fade" mode="out-in">
                <strong v-if="activeContentTab === 3" key="legend1"
                  >Добавяне на отсъствия</strong
                >
              </transition>
            </p>
          </div>
          <div class="new-content-data-item desktop">
            <div class="new-content-data-item-content">
              <transition name="fade" mode="out-in">
                <img
                  src="../assets/img/legend_hr.svg"
                  alt
                  v-if="activeContentTab === 3"
                  key="legend-hr"
                />
                <img
                  src="../assets/img/legendMech.svg"
                  alt
                  v-else-if="activeContentTab === 1"
                  key="legend-mech"
                />
                <img src="../assets/img/legend.svg" alt v-else key="legend" />
              </transition>
            </div>
          </div>
        </div>
        <div class="right-panel" id="rightPanel">
          <!-- OBJECTS CALENDAR -->
          <div
            class="objects-calendar"
            v-if="activeContentTab === 0 && calendars.length"
          >
            <template v-if="activePeriodTab === 0">
              <div
                class="objects-calendar-item"
                v-for="(c, index) in calendars"
                :key="`${index}-${c.company._id}-${c.project._id}`"
              >
                <div
                  class="objects-calendar-item-header"
                  :class="`objects-calendar-item-header--${c.company._id}`"
                >
                  <p
                    class="objects-calendar-item-header__company"
                    @click="filterByCompany(c.company._id)"
                    title="Изберете за да покажете само проектите за този отдел. Натиснете отново, за да покажете всички отдели"
                  >
                    {{ c.company.companyName }}
                  </p>
                  <p :title="c.project.projectName">
                    {{ c.project.projectName }}
                  </p>
                </div>
                <div class="objects-calendar-item-content">
                  <div class="workers-container">
                    <a
                      class="workers-tag-wrapper"
                      v-for="r in c.reports"
                      :key="`${c.project._id}-${r._id}`"
                      target="_blank"
                      :href="`/reports/edit/${r._id}`"
                      @click="handleTagClick()"
                    >
                      <a
                        v-for="(w, j) in r.workers"
                        :key="`${j}-${c.project._id}-${w._id}`"
                        class="workers-tag"
                        :class="{
                          'workers-tag--green':
                            !r.planned &&
                            w.plannedStartHour === w.startHour &&
                            w.plannedEndHour === w.endHour,
                          'workers-tag--red':
                            !r.planned &&
                            (w.plannedStartHour !== w.startHour ||
                              w.plannedEndHour !== w.endHour),
                          'workers-tag--blue': !r.initAsPlanned,
                        }"
                        >{{ w.name }}</a
                      >
                    </a>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="activePeriodTab === 1">
              <div
                class="big-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="date-calendar-item-header">
                  <p>{{ c.date | formatDay }}</p>
                  <p>
                    {{ c.calendars.length }}&nbsp;
                    <span v-if="c.calendars.length === 1">Обект</span>
                    <span v-else>Обекта</span>
                  </p>
                </div>
                <div class="big-calendar-item-content">
                  <div class="companies-container">
                    <a
                      v-for="ca in c.calendars"
                      :key="ca._id"
                      class="companies-tag"
                      :href="`/reports/edit/${ca._id}`"
                      target="_blank"
                      @click="handleTagClick()"
                    >
                      <template v-if="ca">
                        <p>{{ ca.company.companyName }}</p>
                        <p>{{ ca.project.projectName }}</p>
                      </template>
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- MECHANIZATIONS CALENDAR -->
          <div
            class="objects-calendar"
            v-if="activeContentTab === 1 && calendars.length"
          >
            <template v-if="activePeriodTab === 0">
              <div
                class="objects-calendar-item"
                v-for="(c, index) in calendars"
                :key="`${index}-${c.company._id}-${c.project._id}`"
              >
                <div class="objects-calendar-item-header">
                  <p>{{ c.company.companyName }}</p>
                  <p>{{ c.project.projectName }}</p>
                </div>
                <div class="objects-calendar-item-content">
                  <div class="workers-container">
                    <template
                      v-for="x of ['mechanizations', 'rentedMechanizations']"
                    >
                      <a
                        v-for="(m, i) in c[x]"
                        :key="`${x}-${i}-${c.project._id}-${m._id}`"
                        class="workers-tag"
                        :href="`/reports/edit/${c._id}`"
                        :class="{
                          'workers-tag--green':
                            !c.planned && m.items === m.plannedItems,
                          'workers-tag--red':
                            !c.planned && m.items !== m.plannedItems,
                          'workers-tag--blue': !c.initAsPlanned,
                        }"
                        target="_blank"
                        @click="handleTagClick()"
                        :title="`${
                          m.landlord ? 'Наета' : 'Собствена'
                        } механизация`"
                      >
                        <!-- @click.native="$event.stopImmediatePropagation()" -->
                        <span class="mck mechanizations">{{
                          m.landlord ? "m" : "n"
                        }}</span>
                        <span class="name">{{ m.name }}</span>
                      </a>
                    </template>
                  </div>
                </div>
              </div>
            </template>
            <template v-if="activePeriodTab === 1">
              <div
                class="big-calendar-item"
                v-for="c in calendars"
                :key="c._id"
              >
                <div class="date-calendar-item-header">
                  <p>{{ c.date | formatDay }}</p>
                  <p>
                    {{ c.calendars.length }}&nbsp;
                    <span v-if="c.calendars.length === 1">Обект</span>
                    <span v-else>Обекта</span>
                  </p>
                </div>
                <div class="big-calendar-item-content">
                  <div class="companies-container">
                    <a
                      v-for="ca in c.calendars"
                      :key="ca._id"
                      class="companies-tag"
                      :href="`/reports/edit/${ca._id}`"
                      target="_blank"
                      @click.native="handleTagClick()"
                    >
                      <template v-if="ca">
                        <p>{{ ca.company.companyName }}</p>
                        <p>{{ ca.project.projectName }}</p>
                      </template>
                    </a>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- WORKERS CALENDAR -->
          <!-- <div class="workers-calendar" v-if="activeContentTab === 1 && calendars.length">
            <template v-if="activePeriodTab === 0">
              <div class="workers-calendar-item" v-for="c in calendars" :key="c._id">
                <div class="workers-calendar-item-header">
                  <p>{{c.worker.name}}</p>
                </div>
                <div class="workers-calendar-item-content">
                  <div class="companies-container">
                    <router-link
                      v-for="co in c.companies"
                      :key="co._id"
                      class="companies-tag companies-tag--planned"
                      :class="{
                        'companies-tag--green': !co.planned && co.plannedStartHour === co.startHour && co.plannedEndHour === co.endHour,
                        'companies-tag--red': !co.planned && (co.plannedStartHour !== co.startHour || co.plannedEndHour !== co.endHour),
                        'companies-tag--blue': !co.initAsPlanned
                      }"
                      :to="`/reports/edit/${co.report}`"
                      target="_blank"
                      @click.native="$event.stopImmediatePropagation()"
                    >
                      <template v-if="co">
                        <p>{{co.company.companyName}}</p>
                        <p>{{co.project.projectName}}</p>
                      </template>
                    </router-link>
                  </div>
                </div>
              </div>
            </template>
            <template v-else-if="activePeriodTab === 1">
              <div class="big-calendar-item" v-for="c in calendars" :key="c._id">
                <div class="date-calendar-item-header">
                  <p>{{c.date | formatDay}}</p>
                  <p>
                    {{c.workers.length}}&nbsp;
                    <span
                      v-if="c.workers.length === 1"
                    >Работник</span>
                    <span v-else>Работника</span>
                  </p>
                </div>
                <div class="objects-calendar-item-content">
                  <div class="workers-container">
                    <router-link
                      v-for="(w,i) in c.workers"
                      :key="`${c._id}-${i}-${w._id}`"
                      class="workers-tag"
                      :class="{
                        'workers-tag--green': !w.planned && w.plannedStartHour === w.startHour && w.plannedEndHour === w.endHour,
                        'workers-tag--red': !w.planned && (w.plannedStartHour !== w.startHour || w.plannedEndHour !== w.endHour),
                        'workers-tag--blue': !w.initAsPlanned
                      }"
                      :to="`/reports/edit/${w.report}`"
                      target="_blank"
                      @click.native="$event.stopImmediatePropagation()"
                    >{{w.name}}</router-link>
                  </div>
                </div>
              </div>
            </template>
          </div>-->
          <!-- PERSONAL CALENDAR -->
          <div
            class="big-calendar"
            :class="{ 'personal-calendar': activePeriodTab === 0 }"
            v-if="activeContentTab === 2 && calendars.length"
          >
            <div class="big-calendar-item" v-for="c in calendars" :key="c._id">
              <div class="date-calendar-item-header">
                <p>{{ c.date | formatDay }}</p>
                <p>
                  {{ c.calendars.length }}&nbsp;
                  <span v-if="c.calendars.length === 1">Обект</span>
                  <span v-else>Обекта</span>
                </p>
              </div>
              <div class="big-calendar-item-content">
                <a
                  v-for="ca in c.calendars"
                  :key="ca._id"
                  class="personal-tag"
                  :href="`/reports/edit/${ca._id}`"
                  target="_blank"
                  @click="handleTagClick()"
                >
                  <!-- @click.native="$event.stopImmediatePropagation()" -->
                  <template v-if="ca">
                    <div class="left">
                      <p>{{ ca.company.companyName }}</p>
                      <p>{{ ca.project.projectName }}</p>
                    </div>
                    <div class="right">
                      <template v-if="activePeriodTab === 0">
                        <p
                          v-for="(w, index) in ca.workers"
                          :key="`${ca._id}-${index}-${w._id}`"
                          class="worker-color"
                          :class="{
                            'worker-color--green':
                              !ca.planned &&
                              w.plannedStartHour === w.startHour &&
                              w.plannedEndHour === w.endHour,
                            'worker-color--red':
                              !ca.planned &&
                              (w.plannedStartHour !== w.startHour ||
                                w.plannedEndHour !== w.endHour),
                            'worker-color--blue': !ca.initAsPlanned,
                          }"
                        >
                          {{ w.name }}
                        </p>
                      </template>
                      <div
                        v-if="activePeriodTab === 1"
                        class="big-calendar-count-toggle"
                      >
                        <span class="mck2">Q</span>
                        <span>{{ ca.workers.length }}</span>
                      </div>
                    </div>
                  </template>
                </a>
              </div>
            </div>
          </div>
          <!-- ABSENCES -->
          <div
            class="workers-calendar no-results-calendar"
            v-if="activeContentTab === 3"
          >
            <div class="workers-calendar-item">
              <div class="workers-calendar-item-header">
                <p>{{ date | formatDayYear }}</p>
              </div>
              <!-- <div class="workers-calendar-item-content" v-if="!absences.length">
                <p class="no-results-calendar-p">no results</p>
              </div>-->
              <div class="absences-wrapper" v-if="absences.length">
                <p
                  class="absence-row"
                  v-for="a in absences"
                  :key="a._id"
                  @click="handleTagClick(a._id)"
                >
                  <span
                    class="absence-type"
                    :class="`absence-type--${a.type}`"
                    >{{ absenceTypes[a.type] }}</span
                  >
                  <span class="abscence-name">
                    <strong>{{ a.user.name }}</strong>
                  </span>
                  <span
                    >{{ a.from | formatDayYear }} -
                    {{ a.to | formatDayYear }}</span
                  >
                </p>
              </div>
            </div>
          </div>
          <!-- NO RESULTS  -->
          <div
            class="workers-calendar no-results-calendar"
            v-if="!calendars.length && activeContentTab !== 3"
          >
            <div class="workers-calendar-item">
              <div class="workers-calendar-item-header">
                <p v-if="activeContentTab === 0">
                  График планирани и отчетени служители
                </p>
                <p v-if="activeContentTab === 1">
                  График планирана и отчетена механизация
                </p>
                <p v-if="activeContentTab === 2">Личен график</p>
              </div>
              <div class="workers-calendar-item-content">
                <p class="no-results-calendar-p" v-if="activeContentTab === 2">
                  За избрания ден не сте разпределен в никой от обектите
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="fade">
      <AddAbsencesModal
        v-if="isAbsencesModalOpen"
        :selectedCalendarDate="date"
        @close="closeAbsencesModal"
      />
    </transition>
    <transition name="fade">
      <EditAbsenceModal
        v-if="selectedAbsence"
        :id="selectedAbsence"
        @close="closeEditAbscenceModal"
      />
    </transition>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import { mapGetters } from "vuex";
import log from "./mixins/log.js";
import tabsData from "../data/tabsData";
import AddAbsencesModal from "./shared/AddAbsencesModal";
import EditAbsenceModal from "./shared/EditAbsenceModal";
import { getAccess } from "./mixins/getAccess.js";
export default {
  components: {
    Datepicker: Datepicker,
    AddAbsencesModal,
    EditAbsenceModal,
  },
  mixins: [log],
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      "getUser",
      // ...
    ]),
    normativeUrl() {
      const token = localStorage.getItem('token');
      return `${
        process.env.VUE_APP_BASE_URI
      }/normative/${this.date.toISOString()}?token=${token}`;
    },
    normativePdf() {
      return `${process.env.VUE_APP_FILES_URI}/normative_info.pdf`;
    },
  },
  data() {
    return {
      accessCache: {},
      tabsData,
      bg: bg,
      months: [
        "Януари",
        "Февруари",
        "Март",
        "Април",
        "Май",
        "Юни",
        "Юли",
        "Август",
        "Септември",
        "Октомври",
        "Ноември",
        "Декември",
      ],
      absenceTypes: {
        paid: "Платен отпуск",
        unpaid: "Неплатен отпуск",
        illness: "Отпуск по болест",
        compensation: "Компенсация",
      },
      highlightedDates: [],
      highlighted: { to: "", from: "" },
      date: "",
      firstDay: undefined,
      lastDay: undefined,
      format: "MMMM yyyy",
      activePeriodTab: 0,
      activeContentTab: 0,
      calendars: [],
      workers: [],
      absences: [],
      isAbsencesModalOpen: false,
      selectedObject: undefined,
      showMobileDatepicker: false,
      selectedAbsence: "",
      allowExport: false,
      filter: null,
    };
  },
  watch: {
    date() {
      this.showMobileDatepicker = false;
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();
      this.filter = null;
      this.fetchData();
    },
  },
  methods: {
    goToReport(r) {
      this.$router.push(`/reports/edit/${r}`);
    },
    changePeriodTab(n) {
      this.showMobileDatepicker = false;
      this.firstDay = new Date(this.date).GetFirstDayOfWeek();
      this.lastDay = new Date(this.date).GetLastDayOfWeek();
      this.activePeriodTab = n;
      this.filter = null;
      this.fetchData();
    },
    changeContentTab(n) {
      this.activeContentTab = n;
      this.filter = null;
      this.fetchData();
    },
    fetchData() {
      this.calendars = [];
      this.absences = [];
      if (this.activeContentTab === 3) {
        this.getAbsences();
        this.exportPermission();
      } else {
        this.getCalendars();
      }
      this.getHighlighted();
    },
    getAbsences() {
      let url = `${
        process.env.VUE_APP_BASE_URI
      }/absence/date/${this.date.toISOString()}`;

      this.$http.get(url).then((res) => {
        this.absences = res.data;
      });
    },
    getCalendars() {
      this.$store.dispatch("startLoading");

      let type = "";

      // DAILY
      let firstDate = this.date;
      let secondDate = this.date;
      // WHOLE WEEK
      if (this.activePeriodTab === 1) {
        firstDate = new Date(this.date).GetFirstDayOfWeek();
        secondDate = new Date(this.date).GetLastDayOfWeek();
      }

      if (this.activeContentTab === 0) {
        type = "day";
      } else if (this.activeContentTab === 1) {
        type = "mechanizations";
      } else if (this.activeContentTab === 2) {
        type = "workers";
      }

      let requestUrl = `${
        process.env.VUE_APP_BASE_URI
      }/calendar/${type}/${this.date.toISOString()}`;

      // BUILD THE REQUEST URL FOR ALL CALENDARS
      if (this.activeContentTab === 0) {
        // URL
        // DAY
        if (this.activePeriodTab === 0) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}`;
        }
        // WEEK
        else if (this.activePeriodTab === 1) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
        }
      }

      // BUILD THE REQUEST URL FOR ALL WORKERS
      if (this.activeContentTab === 1) {
        // URL
        // DAY
        if (this.activePeriodTab === 0) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}`;
        }
        // WEEK
        else if (this.activePeriodTab === 1) {
          requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}`;
        }
      }

      // BUILD THE REQUEST URL FOR PERSONAL CALENDAR
      if (this.activeContentTab === 2) {
        // URL
        requestUrl = `${
          process.env.VUE_APP_BASE_URI
        }/calendar/${type}/${firstDate.toISOString()}/${secondDate.toISOString()}/${
          this.getUser._id
        }`;
      }

      // console.log(requestUrl);

      if (this.filter) {
        requestUrl += `?filterByCompany=${this.filter}`;
      }

      this.$http
        .get(requestUrl)
        .then((response) => {
          this.$store.dispatch("stopLoading");
          this.calendars = response.data;
        })
        .catch((error) => console.log(error));
    },
    handleTagClick(absenceId) {
      if (absenceId && getAccess(this.activeContentTab, "calendar", true)) {
        this.selectedAbsence = absenceId;
      } else if (!absenceId && !getAccess("reporting", "reports", true)) {
        event.preventDefault();
      }
    },
    filterByCompany(id) {
      this.filter = this.filter ? null : id;
      this.getCalendars();
    },
    changeMonth(e) {
      const currentDate = new Date(this.date).getDate();
      this.date = new Date(e);
      this.date.setDate(currentDate);
    },
    getHighlighted() {
      if (this.activePeriodTab === 1) {
        this.highlighted = { from: this.firstDay, to: this.lastDay };
      } else {
        if (this.activeContentTab === 3) {
          this.highlighted = {
            dates: [],
          };
        } else {
          let type = "workers";

          if (this.activeContentTab === 1) {
            type = "mechanizations";
          }

          const requestUrl = `${
            process.env.VUE_APP_BASE_URI
          }/calendar/highlighted?type=${type}&date=${this.date.toISOString()}`;

          this.$http
            .get(requestUrl)
            .then((response) => {
              this.highlightedDates = [];
              if (response.data.dates) {
                response.data.dates.map((d) => {
                  this.highlightedDates.push(new Date(d));
                });
              }

              this.highlighted = {
                dates: this.highlightedDates,
              };
            })
            .catch((error) => console.log(error));
        }
      }
    },
    toggleExport(e) {
      if (!getAccess("normative", "calendar", true)) {
        e.preventDefault();
      } else if (!this.allowExport) {
        e.preventDefault();
        this.$snotify.warning(
          "За избрания месец няма създадени отчети или отсъствия"
        );
      }
    },
    exportPermission() {
      this.allowExport = false;
      let url = `${
        process.env.VUE_APP_BASE_URI
      }/normative/${this.date.toISOString()}?allow=true`;
      this.$http.get(url).then((response) => {
        this.allowExport = response.data;
      });
    },
    scrollH(e) {
      e = window.event || e;
      var delta = Math.max(-1, Math.min(1, e.wheelDelta || -e.detail));
      document.getElementById("rightPanel").scrollLeft -= delta * 40;
      e.preventDefault();
    },
    openAddAbsencesModal() {
      if (this.activeContentTab === 3) {
        this.isAbsencesModalOpen = true;
      }
    },
    closeAbsencesModal(update) {
      if (update) {
        this.fetchData();
      }
      this.isAbsencesModalOpen = false;
    },
    closeEditAbscenceModal(update) {
      if (update) {
        this.fetchData();
      }
      this.selectedAbsence = "";
    },
    setAccessCache() {
      Object.keys(this.tabsData.calendar.tabValues).forEach((key) => {
        this.accessCache[key] = getAccess(key, "calendar");
      });

      Object.entries(this.accessCache).find((a) => {
        let key = a[0];
        let val = a[1];

        if (key !== "1" && val) {
          if (key === "normative") this.activeContentTab = 3;
          else this.activeContentTab = Number(key);
          return true;
        }

        this.activeContentTab = 1;
      });
    },
  },
  mounted() {
    this.setAccessCache();
    const todayCell = document.getElementsByClassName("today")[0];
    if (todayCell) {
      todayCell.click();
    } else {
      this.date = new Date();
    }

    this.fetchData();
    this.getHighlighted();

    this.$on("mousewheel", this.scrollH, false);
  },
  destroyed() {
    // Stop listening
    this.$off("mousewheel");
  },
};
</script>

<style scoped lang="scss">
/* IT WILL BE A GOOD IDEA TO REFACTOR THE WHOLE CSS  */
label {
  color: #373737;
  font-size: 11px;
  font-weight: 700;
}
.week {
  background-color: #f0f0f7;
  border: 0;
  text-align: center;
  width: 300px;
}
.calendar-wrapper {
  display: flex;
}
.calendar {
  background-color: #f0f0f7;
  padding: 10px 20px;
  transition: all 0.3s;
  width: 100%;
}
.calendar-header {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: space-between;
}
.calendar-header h2 {
  color: #373737;
  font-size: 16px;
}
.calendar-header-left {
  align-items: center;
  display: flex;
  justify-content: space-between;
  /* width: 300px; */
}
.calendar-header-left label {
  margin-right: 10px;
  white-space: nowrap;
}
.calendar-content {
  background-color: #fff;
  border-radius: 4px;
  display: flex;
  margin-top: 10px;
  min-height: calc(100vh - 166px);
  /* max-height: calc(100vh - 166px); */
  padding: 12px 15px;
}
.left-panel {
  display: flex;
  border-right: 1px solid rgba(234, 240, 244, 0.5);
  flex-direction: column;
  margin-right: 22px;
  padding-right: 22px;
  min-width: 22vw;
  width: 22vw;
}
.left-panel-header {
  align-items: center;
  display: flex;
  height: 46px;
  min-height: 46px;
  justify-content: space-between;
  padding-bottom: 10px;
}
.views {
  display: flex;
  justify-content: center;
  width: 100%;
}

.view {
  background-color: #f5f5f5;
  border: 1px solid #d7dae2;
  color: #4d4f5c;
  cursor: pointer;
  font-size: 12px;
  font-weight: 700;
  height: 36px;
  min-width: 80px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 50%;
}
.view:first-child {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.view:last-child {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.view-active {
  background-color: var(--color-main);
  border: 1px solid var(--color-main);
  color: #ffffff;
}
.view:hover {
  background-color: #f9f9f9;
}
.view-active:hover {
  background-color: #f57417;
}
.view:nth-child(1n + 3) {
  width: 1%;
  min-width: 60px;
}
.new-content-data-item {
  background-color: transparent;
  height: 100%;
  overflow: auto;
  position: relative;
  max-height: 50vh;
  width: 100%;
}
.new-content-data-item-toggle {
  background-color: transparent;
  color: #fff;
  cursor: default;
  font-size: 11px;
  height: 30px;
  justify-content: center;
  min-height: 30px;
  margin-top: 10px;
  padding-left: 30px;
  text-align: center;
  width: 100%;
  z-index: 1;
}
.new-content-data-item-toggle .mck2 {
  font-size: 18px;
  left: 10px;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.new-content-data-item-toggle--hoverable {
  background-color: var(--color-main);
  cursor: pointer;
  padding-right: 15px;
}
.new-content-data-item-toggle--hoverable:hover {
  opacity: 0.8;
}

.right-panel {
  display: flex;
  flex-direction: column;
  /* overflow: auto; */
  overflow-y: auto;
  width: 100%;
}
.selected-date {
  font-size: 16px;
  padding: 7px 0;
}
.overtime {
  background-color: rgba(252, 252, 229, 0.63);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
.normal {
  background-color: rgba(232, 245, 233, 0.37);
  border: 1px solid #eaf0f4;
  transform: rotate(270deg);
}
/* WORKERS */
.workers-calendar,
.objects-calendar,
.big-calendar {
  display: flex;
  height: 100%;
}
.workers-calendar-item,
.objects-calendar-item,
.big-calendar-item {
  align-items: center;
  display: flex;
  flex-direction: column;
  min-width: 180px;
  width: 180px;
}
.workers-calendar-item-header,
.objects-calendar-item-header,
.date-calendar-item-header {
  align-items: center;
  background-color: #f5f6fa;
  border: 1px solid #eaf0f4;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-bottom: 10px;
  max-height: 36px;
  min-height: 36px;
  width: 100%;
}
.workers-calendar-item-header {
  max-height: 36px;
  min-height: 36px;
}
.workers-calendar-item:first-child .workers-calendar-item-header,
.objects-calendar-item:first-child .objects-calendar-item-header,
.big-calendar-item:first-child .date-calendar-item-header {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
}
.workers-calendar-item:last-child .workers-calendar-item-header,
.objects-calendar-item:last-child .objects-calendar-item-header,
.big-calendar-item:last-child .date-calendar-item-header {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
}
.workers-calendar-item-header p,
.objects-calendar-item-header p,
.date-calendar-item-header p {
  font-size: 9px;
  font-weight: 400;
  line-height: 10px;
  opacity: 0.5;
  overflow: hidden;
  text-align: center;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
  width: 100%;
}
.workers-calendar-item-header p:nth-child(2),
.objects-calendar-item-header p:nth-child(2),
.date-calendar-item-header p:nth-child(2) {
  font-weight: 700;
  font-size: 12px;
  line-height: 12px;
}
.objects-calendar-item-header p {
  padding: 0 5px;
}
.workers-calendar-item-header p:nth-child(3),
.objects-calendar-item-header p:nth-child(3),
.date-calendar-item-header p:nth-child(3) {
  font-size: 12px;
  font-weight: 700;
}
.objects-calendar-item-header--5eabbdb1f68f8a150bb1a744 {
  background-color: rgba(8, 47, 201, 0.2);
}
.objects-calendar-item-header--5eddd7525464233320ad4d91 {
  background-color: rgba(84, 55, 183, 0.2);
}
.objects-calendar-item-header--5eaea6bef68f8a150bb1b3b2 {
  background-color: rgba(10, 112, 158, 0.2);
}

.objects-calendar-item-header .objects-calendar-item-header__company {
  border-radius: 20px;
  cursor: pointer;
  color: #fff;
  font-weight: 700;
  display: inline-flex;
  letter-spacing: 2px;
  margin-bottom: 2px;
  opacity: 1;
  padding: 1px 10px;
  transition: all 0.3s;
  width: initial; /* yes it's needed */
}
.objects-calendar-item-header--5eabbdb1f68f8a150bb1a744
  .objects-calendar-item-header__company {
  background-color: #082fc9;
}
.objects-calendar-item-header--5eddd7525464233320ad4d91
  .objects-calendar-item-header__company {
  background-color: #5437b7;
}
.objects-calendar-item-header--5eaea6bef68f8a150bb1b3b2
  .objects-calendar-item-header__company {
  background-color: #0a709e;
}
.objects-calendar-item-header .objects-calendar-item-header__company:hover {
  opacity: 0.5;
}
.workers-calendar-item-content,
.objects-calendar-item-content,
.big-calendar-item-content {
  align-items: center;
  /* border: 1px solid #eaf0f4; */
  border-radius: 4px;
  flex-direction: column;
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  /* padding: 5px; */
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  position: relative;
  width: 176px;
}
/* .workers-calendar-item-content:hover,
.objects-calendar-item-content:hover,
.big-calendar-item-content:hover {
  background-color: #edf1f5;
} */
.new-content-data-item-content {
  align-items: center;
  display: flex;
  padding: 10px;
}
.new-content-data-item-content img {
  max-height: 100%;
  width: 100%;
}
.add-items-wrapper {
  width: 100%;
}
.no-results-calendar {
  width: 100%;
}
.no-results-calendar .workers-calendar-item {
  width: 100%;
}
.no-results-calendar .workers-calendar-item-content {
  width: 100%;
  cursor: default;
}
.no-results-calendar .workers-calendar-item-content:hover {
  background-color: transparent;
}
.companies-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  justify-content: center;
  width: 100%;
}
.companies-tag,
.personal-tag {
  align-items: center;
  background-color: #d3dae2;
  color: #000;
  display: flex;
  border-radius: 4px;
  flex-direction: column;
  height: 100%;
  justify-content: center;
  padding: 5px;
  margin-bottom: 5px;
  min-height: 180px;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.companies-tag:hover {
  opacity: 0.7;
}
.personal-tag {
  background-color: #d3dae2;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
}
.personal-tag:hover {
  opacity: 0.7;
}
.companies-tag:last-child,
.personal-tag:last-child {
  margin-bottom: 0;
}
.companies-tag p,
.personal-tag p {
  font-size: 10px;
  line-height: 11px;
  opacity: 0.5;
  margin: 3px 0;
  text-align: center;
}
.companies-tag p:nth-child(3),
.personal-tag p:nth-child(3) {
  font-size: 13px;
  line-height: 13px;
  margin: 5px 0 0;
  text-align: center;
  opacity: 1;
}
.workers-container {
  display: flex;
  flex-direction: column;
  height: 100%;
  overflow: auto;
  justify-content: center;
  width: 100%;
}
.type-paid {
  background-color: #e6f3e6;
}
.type-unpaid {
  background-color: #f3eae6;
}
.type-hospital {
  background-color: #e6ecf3;
}
.workers-tag-wrapper {
  align-items: center;
  /* background-color: rgba(158, 158, 158, 0.8); */
  border: solid;
  border-color: #000;
  cursor: pointer;
  display: flex;
  height: 100%;
  flex-direction: column;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  padding: 5px;
}
.workers-tag-wrapper:hover {
  /* opacity: 0.7; */
  filter: grayscale(1);
}
.workers-tag-wrapper:not(:first-child) {
  margin-top: 5px;
}
.workers-tag {
  align-items: center;
  background-color: #ece0c6;
  border-radius: 4px;
  color: #000;
  cursor: pointer;
  display: flex;
  font-size: 10px;
  height: 100%;
  justify-content: center;
  line-height: 10px;
  padding: 5px 10px;
  position: relative;
  text-align: center;
  -webkit-transition: all 0.3s;
  -moz-transition: all 0.3s;
  -ms-transition: all 0.3s;
  -o-transition: all 0.3s;
  transition: all 0.3s;
  width: 100%;
}
.workers-tag:not(:first-child) {
  margin-top: 4px;
}
.companies-tag--planned {
  background-color: #ece0c6;
}
.companies-tag--green,
.workers-tag--green {
  background-color: #d1eecd;
}
.companies-tag--red,
.workers-tag--red {
  background-color: #f1aeae;
}
.companies-tag--blue,
.workers-tag--blue {
  background-color: #cce7ff;
}
.workers-tag:hover {
  opacity: 0.7;
}
.workers-tag-wrapper .workers-tag:hover {
  opacity: 1;
}
.workers-tag .name {
  position: relative;
  z-index: 1;
}
.workers-tag .mck.mechanizations {
  color: #fff;
  opacity: 0.4;
  font-size: 150px;
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.big-calendar-count-toggle {
  align-items: center;
  background-color: #104d80;
  border-radius: 30px;
  color: #fff;
  display: flex;
  justify-content: center;
  margin-top: 10px;
  position: relative;
  padding: 5px 10px;
}
.big-calendar-count-toggle span {
  font-size: 14px;
}
.big-calendar-count-toggle .mck2 {
  font-size: 20px;
  margin-right: 5px;
}
.company {
  align-items: start;
  padding: 4px;
}
.btn {
  margin: 0;
}
/* * */
/* PERSONAL */
/* * */
.personal-calendar {
  display: block;
}
.personal-calendar .big-calendar-item {
  width: 100%;
}
.personal-calendar .big-calendar-item-content {
  width: 100%;
}
.personal-calendar .personal-tag {
  align-items: stretch;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  min-height: 150px;
  padding: 20px 10px;
}
.personal-calendar .personal-tag .left {
  border-right: 1px solid #104d80;
  margin-right: 50px;
  padding: 0 8px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .left p {
  text-align: right;
}
.personal-calendar .personal-tag .right {
  border-left: 1px solid #104d80;
  margin-left: 50px;
  padding: 0 10px;
  position: relative;
  width: 50%;
}
.personal-calendar .personal-tag .right p {
  color: #104d80;
  font-size: 12px;
  line-height: 16px;
  margin: 0;
  opacity: 1;
  text-align: left;
}
.personal-calendar .personal-tag .right .worker-color {
  color: #af8730;
}
.personal-calendar .personal-tag .right .worker-color--green {
  color: #4c9e41;
}
.personal-calendar .personal-tag .right .worker-color--red {
  color: #a53333;
}
.personal-calendar .personal-tag .right .worker-color--blue {
  color: #104d80;
}
.personal-calendar .personal-tag .left::before,
.personal-calendar .personal-tag .right::before {
  color: #104d80;
  content: "P";
  font-family: "mck2";
  font-size: 20px;
  position: absolute;
  top: 0;
}
.personal-calendar .personal-tag ::before {
  right: -30px;
}
.personal-calendar .personal-tag .right::before {
  content: "Q";
  left: -30px;
}
.mobile-inline {
  display: none;
}
.mobile-datepicker {
  display: none;
}
/* ABSENCES */
.absences-wrapper {
  height: 100%;
  /* display; */
  width: 100%;
}
.absence-row {
  cursor: pointer;
  margin: 10px 0;
  transition: all 0.3s;
}
.absence-row:hover {
  opacity: 0.6;
}
.absence-type {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  font-size: 12px;
  font-weight: 500;
  height: 22px;
  justify-content: center;
  line-height: 12px;
  width: 170px;
}
.absence-type--paid {
  background-color: #e1bee7;
  color: #4a148c;
}
.absence-type--unpaid {
  background-color: #cfd8dc;
  color: #263238;
}
.absence-type--illness {
  background-color: #bbdefb;
  color: #0d47a1;
}
.absence-type--compensation {
  background-color: #b2dfdb;
  color: #004d40;
}
.abscence-name {
  display: inline-block;
  margin: 0 20px;
}
.btn--help {
  background-color: #5690c9;
  margin-left: 5px;
  width: 30px;
}
.btn--help:hover {
  background-color: #6c9fd3;
}
@media screen and (max-width: 1440px) {
  .left-panel {
    min-width: 25vw;
    width: 25vw;
  }
}
@media screen and (max-width: 1366px) {
  .left-panel {
    min-width: 28vw;
    width: 28vw;
  }
}
@media screen and (max-width: 1000px) {
  .desktop {
    display: none;
  }
  .mobile-inline {
    display: inline;
  }
  .calendar {
    padding: 10px 15px;
  }
  .calendar-content {
    flex-direction: column;
  }
  .calendar-header {
    position: relative;
  }
  .left-panel {
    border: none;
    margin: 0;
    padding: 0;
    width: 100%;
  }
  .left-panel-header {
    padding-bottom: 15px;
  }
  .mobile-datepicker {
    display: inline-flex;
    position: relative;
    width: 100%;
  }
  .mobile-datepicker-toggle {
    align-items: center;
    background-color: #f5f5f5;
    border: 1px solid #d7dae2;
    border-radius: 4px;
    cursor: pointer;
    display: inline-flex;
    justify-content: space-between;
    height: 30px;
    padding: 0 10px;
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
    width: 100%;
  }
  .mobile-datepicker-toggle:hover {
    background-color: #f9f9f9;
  }
  .mobile-datepicker-toggle span {
    font-size: 12px;
  }
  .mobile-datepicker-toggle .mck {
    -webkit-transition: all 0.3s;
    -moz-transition: all 0.3s;
    -ms-transition: all 0.3s;
    -o-transition: all 0.3s;
    transition: all 0.3s;
  }
  .mobile-datepicker-toggle .rotate-arrow {
    transform: scale(-1);
  }
  .mobile-datepicker-wrapper {
    position: absolute;
    /* height: 100%; */
    /* left: 50%; */
    top: calc(100% + 10px);
    /* width: 100%; */
    z-index: 1;
  }
  .calendar-header-left {
    margin-left: 10px;
  }
  .no-results-calendar-p {
    font-size: 12px;
    text-align: center;
  }
  .objects-calendar-item-content-add-hidden {
    display: none;
  }
}
@media screen and (max-width: 600px) {
  .mobile-datepicker {
    position: initial;
  }
  .view {
    min-width: 40px;
  }
  .personal-calendar .personal-tag {
    justify-content: center;
    flex-direction: column;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    border-left: 1px solid #104d89;
    border-right: none;
    margin: 0 0 0 35px;
    width: calc(100% - 35px);
  }
  .personal-calendar .personal-tag .left {
    margin-bottom: 10px;
  }
  .personal-calendar .personal-tag .left p,
  .personal-calendar .personal-tag .right p {
    text-align: left;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    right: initial;
    left: -30px;
  }
  .companies-tag p,
  .personal-tag p {
    font-size: 9px;
    margin: 0;
  }
  .companies-tag p:nth-child(3),
  .personal-tag p:nth-child(3) {
    font-size: 12px;
    margin: 0;
  }
  .personal-calendar .personal-tag .right p {
    font-size: 11px;
    line-height: 14px;
  }
  .no-results-calendar-p {
    font-size: 10px;
  }
}
@media screen and (max-width: 440px) {
  .mobile-datepicker-toggle span {
    font-size: 10px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    font-size: 15px;
  }
  .personal-calendar .personal-tag .left,
  .personal-calendar .personal-tag .right {
    width: calc(100% - 25px);
    margin-left: 25px;
  }
  .personal-calendar .personal-tag .left::before,
  .personal-calendar .personal-tag .right::before {
    left: -25px;
  }
}
</style>
